import type { Chapter } from '@code-arcade/engine'

export const chapter2: Chapter = {
  id: 'chapter-2',
  number: 2,
  title: 'Scale Up',
  company: 'Blink.io',
  devTitle: 'Mid-Level Engineer',
  conflict: 'User base hits 50k overnight. The O(n²) sorts buckle. Time to divide and conquer.',
  intro: [
    {
      character: 'the-algorithm',
      mood: 'idle',
      dialogue: 'Six months later. Dev Lama gets a recruiter DM.',
    },
    {
      character: 'dev-lama',
      mood: 'idle',
      dialogue: 'Blink.io. Series B. "Move fast" in the job post. Classic.',
    },
    {
      character: 'barry-holt',
      mood: 'urgent',
      dialogue:
        'We have 50,000 users sorting their feeds. Your bubble sort is melting the servers.',
    },
    {
      character: 'priya-nair',
      mood: 'idle',
      dialogue:
        'Divide and conquer. Split the array, sort each half, merge them back. O(n log n).',
    },
    {
      character: 'dev-lama',
      mood: 'stressed',
      dialogue: 'That sounds like two problems instead of one.',
    },
    {
      character: 'priya-nair',
      mood: 'happy',
      dialogue: 'Exactly. And both are easier than the original.',
    },
  ],
  challengeIds: ['merge-sort'],
}
